import { render, staticRenderFns } from "./partner-list.vue?vue&type=template&id=66e914a3&scoped=true&"
import script from "./partner-list.vue?vue&type=script&lang=js&"
export * from "./partner-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e914a3",
  null
  
)

export default component.exports